import React from "react";
import S from "./FundManagers.styled";
import GatsbyLink from "@/components/core-blocks/GatsbyLink";
import { gatsbyImageHelper } from "@/src/helpers";
import FileIcon from "@/assets/file.svg";

export interface FundTabsProps {
    trustees: any;
    factSheets: any;
    sustainabilityLink: any;
    placementOrientation: any;
    text: any;
}

const FundManagers: React.FC<FundTabsProps> = ({
    trustees,
    factSheets,
    sustainabilityLink,
    placementOrientation,
    text,
}) => {

    const renderTrustees = trustees?.map(({ trusteeInfo }, index) => {
        const imageData = gatsbyImageHelper(trusteeInfo.image);

        return (
        <S.Trustee key={index}>
            {imageData && (
            <S.TrusteeImage image={imageData} alt={trusteeInfo.name} />
            )}
            <S.TrusteeInfo>
            <S.TrusteeName>{trusteeInfo.name}</S.TrusteeName>
            <S.TrusteeText>{trusteeInfo.shortInfo}</S.TrusteeText>
            </S.TrusteeInfo>
        </S.Trustee>
        );
    });

    const renderFactSheets = factSheets?.map(({ file }, index) => {
        return (
        <S.Fact key={index} href={file.localFile.publicURL} download>
            <S.FactTitle>{file.title}</S.FactTitle>
            <FileIcon />
        </S.Fact>
        );
    });

    return (
        <S.FundManagerWrapper id="fundManagers">
              
          <S.H4>Förvaltare</S.H4>

          <S.FindManagerSplitSection>

            <S.TextContainer>
              <S.TrusteesWrapper>{renderTrustees}</S.TrusteesWrapper>
            </S.TextContainer>

            <S.TextContainer>
              <S.TextWrapper>
                <S.H5>Placeringsinriktning</S.H5>
                <S.Text>{placementOrientation}</S.Text>
              </S.TextWrapper>
              <S.WysiwygText dangerouslySetInnerHTML={{ __html: text }} />
            </S.TextContainer>

          </S.FindManagerSplitSection>

          <S.TextContainer>
            <S.FactWrapper>
              {renderFactSheets}
              <GatsbyLink link={sustainabilityLink} style="secondary" />
            </S.FactWrapper>
          </S.TextContainer>
          
        </S.FundManagerWrapper>
    );
};

export default FundManagers;
